import Trans from 'next-translate/Trans'
import { useEffect, useState } from 'react'
import useSocket from 'tennders-common/hooks/useSocket'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import useOffers from 'tennders-market/offer/hooks/useOffers'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useSession from 'tennders-auth/hooks/useSession'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import CounterOffer from '../../CounterOffer'
import ActionButtons from './ActionButtons'
import { DealTimer } from './deal/DealTimer'
import { DealPassed } from './deal/DealPassed'
import { DealConfirm } from './deal/DealConfirm'
import { OfferLine } from './deal/OfferLine'
import { DealClose } from './deal/DealClose'

const SingleOffer = ({ offer, offerCount, transaction }) => {
  const {
    selectedOffer,
    setSelectedOffer,
    refreshOffer
  } = useOffers()
  const [myoffer, setmyoffer] = useState(offer)
  const { refresh, setRefresh } = useSocket()
  const { refreshTransaction } = useTransactions()
  const { refreshOffers } = useOffers()
  const { isBroker } = useSession()
  const { closeTransaction, transaction: offerTransaction } = useTransaction()
  const {
    counterMode,
    confirmDeal,
    rejectOffer,
    setCounterMode,
    revertBidding
  } = useOffer()

  useEffect(() => {
    setmyoffer(offer)
  }, [offer])

  useEffect(() => {
    if (refresh === `${REFRESH_TYPES.OFFER}-${myoffer?.id}`) {
      setSelectedOffer(myoffer?.lastOffer)
      refreshOffer({
        transactionId: transaction?.id,
        offerId: offer?.id,
        callback: (singleOffer) => {
          setmyoffer(singleOffer)
        }
      })
    }
  }, [refresh])

  return (
    <table
      data-id={myoffer?.id}
      data-type="offer"
      onClick={() => setSelectedOffer(myoffer?.lastOffer)}
      className={`w-100 tennders-table-zebra cursor-pointer${selectedOffer?.id === myoffer?.lastOffer?.id && offerCount > 1 ? ' bg-color-s' : ''}`}
    >
      <tbody>
        <tr>
          <td className="w-50">
            {(
              myoffer?.isInternalOffer
                ? <h4 className="bold mb-0">{myoffer?.owner}</h4>
                : (
                  <>
                    <h4 className="bold mb-0">{myoffer?.companyName}</h4>
                    <p><i>{myoffer?.owner}</i></p>
                  </>
                )

            )}
          </td>
          <td className="text-right w-50 text-12">
            {myoffer?.lastOffer?.isRouteChanged
              ? (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} aria-hidden="true" />
                  <Trans i18nKey="offer:routeHasChanged" />

                </>
              ) : null}
          </td>
        </tr>
        {(selectedOffer?.id && myoffer?.lastOffer?.id !== selectedOffer?.id) && (
          <tr>
            <td style={{ cursor: 'pointer' }} className="w-100" colSpan={2}>
              <Trans i18nKey="offer:clickForDetails" />

            </td>
          </tr>
        )}
        <tr className="border-b" style={{ minHeight: 200 }}>
          <td className="text-12 w-50">
            <OfferLine
              bold
              offer={myoffer?.lastOffer}
              title={myoffer?.offers?.length > 0
                ? <Trans i18nKey="offer:currentOffer" />
                : <Trans i18nKey="offer:firstOffer" />}
            />
            {myoffer?.offers?.map((cOffer) => (
              <OfferLine
                key={cOffer?.id}
                offer={cOffer}
                title={cOffer?.owner}
              />
            ))}
          </td>
          <td className="w-50" style={{ whiteSpace: 'normal' }}>
            <div className="pos-rel">
              {counterMode === myoffer?.lastOffer?.id
                ? <CounterOffer />
                : (
                  <>
                    <ActionButtons offer={myoffer?.lastOffer} />
                    <DealTimer
                      offer={myoffer?.lastOffer}
                      confirmDeal={confirmDeal}
                      rejectOffer={rejectOffer}
                      refreshTransaction={refreshTransaction}
                      setRefresh={setRefresh}
                    />

                    <DealClose offer={myoffer?.lastOffer} />
                    <DealConfirm offer={myoffer?.lastOffer} />
                    <DealPassed
                      offer={myoffer?.lastOffer}
                      setCounterMode={setCounterMode}
                      revertBidding={revertBidding}
                      refreshOffers={refreshOffers}
                      isBroker={isBroker}
                      closeTransaction={closeTransaction}
                      transaction={offerTransaction}
                      setRefresh={setRefresh}
                    />
                  </>
                )}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default SingleOffer
